import { Grid } from '@mui/material';
import { useAuthApi, useMessage } from 'app/context';
import { useForm } from 'app/hooks';
import { Button, TextField, Typography } from 'app/shared';
import { buildErrorDetails, buildErrorMessage, ROUTES } from 'app/utils';
import { IResetPasswordRequest } from 'generated/axios';
import { t } from 'i18next';
import { isEmpty } from 'lodash';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const ResetPassword = () => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  const { authApi } = useAuthApi();
  const { success, error } = useMessage();
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [defaultValues] = useState<IResetPasswordRequest>({ token: token as string, new_password: '' });

  const send = useCallback(
    (form: IResetPasswordRequest) => {
      setLoading(true);
      authApi
        .resetPassword(form)
        .then((resp) => {
          if (resp.status >= 400) {
            return Promise.reject(resp);
          }
          success({ message: t('resetPassword.success') as string });
          navigate(ROUTES.login);
        })
        .catch((err) => {
          error({ message: buildErrorMessage(err) });
          setErrors(buildErrorDetails(err));
        })
        .finally(() => setLoading(false));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [authApi],
  );

  const { bindTextField, setErrors, submit, form } = useForm<IResetPasswordRequest>({
    defaultValues: defaultValues,
    onSubmit: send,
  });

  return (
    <Grid container width={'40%'} textAlign={'center'} justifySelf={'center'} gap={4}>
      <Grid size={12}>
        <Typography detailTitle>{t('resetPassword.title')}</Typography>
      </Grid>
      <Grid size={12}>
        <Typography>{t('resetPassword.insertNewPassword')}</Typography>
      </Grid>
      <Grid size={12}>
        <TextField label={t('resetPassword.newPassword')} {...bindTextField({ field: 'new_password' })} />
      </Grid>
      <Grid size={12}>
        <Button onClick={submit} disabled={isEmpty(form.new_password)} loading={loading} sx={{ width: '150px' }}>
          {t('actions.submit')}
        </Button>
      </Grid>
    </Grid>
  );
};
